import React from 'react';
import {
  Alert,
  CardHeader,
  CardAvatar,
  CenterTextWrapper,
  FocusedCard,
  VerticalSpace,
} from '@brokerbay/design-components';

import { MailFilled } from '@ant-design/icons';
import { Link } from 'components';

export const NotFoundView = () => (
    <FocusedCard>
      <VerticalSpace>
        <CardHeader
          title="Invitation Link Expired"
          icon={<CardAvatar icon={MailFilled} />}
        />
        <Alert
          type="error"
          message="This invitation link has expired. Please check your inbox for a newer invitation or click the link below to sign up again."
        />
        <CenterTextWrapper>
          <Link href="#">Sign Up Again</Link>
        </CenterTextWrapper>
      </VerticalSpace>
    </FocusedCard>
  );
